import React from "react";
import { Container, Header, Icon, Button, Segment } from "semantic-ui-react";
import { useHistory } from "react-router-dom";

const NotFound = () => {
  const history = useHistory();


  return (
    <Container textAlign="center" style={{ marginTop: "5rem" }}>
      <Segment padded="very" raised>
        <Icon name="warning circle" size="huge" color="red" />

        <Header as="h1" style={{ marginTop: "1rem" }}>
          Page Not Found
        </Header>


        <Header.Subheader style={{ fontSize: "1.2rem", marginTop: "0.5rem" }}>
          The page you're looking for doesn't exist or you don't have access.
        </Header.Subheader>

        <Button
          color="blue"
          size="large"
          style={{ marginTop: "2rem" }}
          onClick={() => history.push("/dashboard")}
        >
          Go Back to Dashboard
        </Button>
      </Segment>
    </Container>
  );
};

export default NotFound;